import React, { useState, useCallback, useEffect } from "react";

function HeaderTable({ filter, onChange }) {
  const [sortType, setSortType] = useState({ column: null, type: null });
  const [pendingSort, setPendingSort] = useState(null);
  const [amount, setAmount] = useState(0);

  const [filterVisible, setFilterVisible] = useState({
    name: false,
    id: false,
    type: false,
    amount: false,
    projectId: false,
    complainAmount: false,
    total: false,
  });

  useEffect(() => {
    if (pendingSort) {
      onChange?.(pendingSort);
      setPendingSort(null);
    }
  }, [pendingSort, onChange]);

  const toggleSort = (column) => {
    setFilterVisible((prev) => {
      const current = prev[column];
      const nextState = current === "asc" ? "desc" : current === "desc" ? null : "asc";

      const resetAll = Object.fromEntries(Object.keys(prev).map((key) => [key, null]));
      return { ...resetAll, [column]: nextState };
    });

    setSortType((prev) => {
      const next = prev.column === column ? (prev.type === "asc" ? "desc" : prev.type === "desc" ? null : "asc") : "asc";
      setPendingSort({ sortBy: column, sortType: next });
      return { column, type: next };
    });
  };

  const handleFilter = useCallback(
    (key, filterBy) => {
      if (filterBy === "is_deduction") {
        onChange?.({ deduction: key });
      } else if (filterBy === "installment_type") {
        onChange?.({ installmentType: key });
      }
    },
    [onChange]
  );

  const handleResetFilter = useCallback(
    (filterBy) => {
      console.log(filterBy);
      if (filterBy === "deduction") {
        onChange?.({ deduction: null });
      } else if (filterBy === "installmentType") {
        onChange?.({ installmentType: null });
      } else if (filterBy === "initial_amount") {
        setAmount(0);
        onChange?.({ initial_amount: 0 });
      }
    },
    [onChange]
  );

  const widthStyle = {
    no: {
      width: "80px",
      minWidth: "80px",
      maxWidth: "80px",
      flexShrink: "0",
      position: "sticky",
      left: "0",
      backgroundColor: "#f8f8f8",
      zIndex: 9999,
    },
    worker_id: {
      width: "135px",
      minWidth: "135px",
      maxWidth: "135px",
      flexShrink: "0",
      position: "sticky",
      left: "80px",
      backgroundColor: "#f8f8f8",
      zIndex: 9999,
    },
    worker_name: {
      width: "200px",
      minWidth: "200px",
      maxWidth: "200px",
      flexShrink: "0",
      position: "sticky",
      left: "215px",
      backgroundColor: "#f8f8f8",
      zIndex: 9999,
    },
    worker_type: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    initial_amount: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    cicilanUnpaid: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    ongkir: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    deduction: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    installmentType: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    notes: { width: "365px", minWidth: "365px", maxWidth: "365px" },
    durasi: { width: "170px", minWidth: "170px", maxWidth: "170px" },
    status: { width: "200px", minWidth: "200px", maxWidth: "200px" },
    final_amount: { width: "250px", minWidth: "250px", maxWidth: "250px" },
    action: {
      width: "100px",
      minWidth: "100px",
      maxWidth: "100px",
      flexShrink: "0",
      position: "sticky",
      right: "0",
      backgroundColor: "#f8f8f8",
    },
  };

  const columns = [
    { key: "no", label: "No", sortAble: false, filterable: false },
    { key: "worker_id", label: "Worker ID", sortAble: true, filterable: false },
    { key: "worker_name", label: "Worker Name", sortAble: true, filterable: false },
    { key: "worker_type", label: "Worker Type", sortAble: true, filterable: false },
    { key: "initial_amount", label: "Amount", sortAble: true, filterable: true },
    { key: "cicilanUnpaid", label: "Cicilan Unpaid", sortAble: false, filterable: false },
    { key: "ongkir", label: "Ongkir", sortAble: false, filterable: false },
    { key: "deduction", label: "Deduction", sortAble: false, filterable: true },
    { key: "installmentType", label: "Type", sortAble: false, filterable: true },
    { key: "notes", label: "Note", sortAble: false, filterable: false },
    { key: "durasi", label: "Durasi", sortAble: false, filterable: false },
    { key: "status", label: "Status", sortAble: false, filterable: false },
    { key: "final_amount", label: "Total", sortAble: true, filterable: false },
    { key: "action", label: "Action", sortAble: false, filterable: false },
  ];

  const dataFilterAmount = [];
  const dataFilterStatus = [
    { key: "status", label: "Status" },
    { key: "durasi", label: "Durasi" },
  ];
  const dataFilterDeduction = [
    { key: "1", filter_by: "is_deduction", label: "Worker Dengan Cicilan" },
    { key: "0", filter_by: "is_deduction", label: "Worker Tanpa Cicilan" },
  ];
  const dataFilterNote = [
    { key: "alat", filter_by: "installment_type", label: "Alat" },
    { key: "atribut", filter_by: "installment_type", label: "Atribut" },
    { key: "material", filter_by: "installment_type", label: "Material" },
  ];

  const filterGroups = {
    initial_amount: dataFilterAmount,
    deduction: dataFilterDeduction,
    installmentType: dataFilterNote,
    status: dataFilterStatus,
    durasi: dataFilterStatus,
    final_amount: dataFilterAmount,
  };

  return (
    <>
      {columns.map((col, index) => (
        <div
          key={col.key}
          className={`flex flex-row justify-content-between align-items-center p-3 m-0 p-0 w-full cursor-pointer select-none ${
            index === columns.length - 1
              ? "border-left-1 border-200"
              : index < columns.length - 2
              ? "border-right-1 border-200"
              : ""
          }`}
          style={{ ...widthStyle[col.key], height: "50px", minHeight: "50px", maxHeight: "50px" }}
        >
          <h6 className="fw-bold m-0" style={{ fontSize: "13px" }} onClick={col.sortAble ? () => toggleSort(col.key) : null}>
            {col.label} {filter[col.key] ? <i className="fa fa-circle text-xs"></i> : ''}
          </h6>

          <div className="flex flex-row justify-content-center align-items-center gap-2">
            {col.sortAble && filterVisible[col.key] && (
              <div
                className="flex flex-row justify-content-center align-items-center gap-2"
                onClick={col.sortAble ? () => toggleSort(col.key) : null}
              >
                <i
                  className={`pi ${
                    filterVisible[col.key] === "asc" ? "pi-arrow-down" : "pi-arrow-up"
                  } text-xs cursor-pointer`}
                  style={{ color: "#708090" }}
                ></i>
              </div>
            )}

            {col.filterable && filterGroups[col.key] && (
              <div className="dropdown">
                <button className="btn btn-primary btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i className="fa fa-filter"></i>
                </button>
                <div className="dropdown-menu" style={{ width: "max-content", maxWidth: "400px" }}>
                  <div className="flex flex-column align-items-start w-full justify-content-between select-none p-3">
                    <h5 className="font-semibold text-blue-600">
                      Filter {col.label === "Amount" ? "Min" : ""} {col.label}
                    </h5>
                    <div className="flex flex-column justify-content-between align-items-start w-full gap-2">
                      <div className="flex flex-row justify-content-start align-items-center gap-2 w-full flex-wrap">
                        {col.label !== "Amount" ? (
                          filterGroups[col.key].map((item) => (
                            <div className="w-auto" key={item.key}>
                              <button
                                className={`btn ${filter[col.key] === item.key ? "btn-primary" : "btn-outline-primary"} btn-sm`}
                                type="button"
                                onClick={() => handleFilter(item.key, item.filter_by)}
                              >
                                {item.label}
                              </button>
                            </div>
                          ))
                        ) : (
                          <div className="w-100">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Masukkan nominal"
                              value={
                                amount
                                  ? new Intl.NumberFormat("id-ID", {
                                      style: "currency",
                                      currency: "IDR",
                                      minimumFractionDigits: 0,
                                    }).format(amount)
                                  : ""
                              }
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                setAmount(Number(numericValue));
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  onChange?.({ initial_amount: Number(amount) || 0 });
                                }
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div className="d-flex gap-2 w-full">
                        <button className="btn btn-warning btn-sm w-100" data-bs-dismiss="dropdown">
                          Tutup
                        </button>
                        <button className="btn btn-danger btn-sm w-100" data-bs-dismiss="dropdown" onClick={() => handleResetFilter(col.key)}>
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
}

export default HeaderTable;
